import {
  BookingHotelRoomBookingBillingRead,
  LocationRoomTypeApi,
  LocationRoomTypeRead,
  LocationRoomTypesGetCollection200Response,
  ReservationRoomRead,
} from '@/api';
import helpers from '@/services/helpers';
import { State } from '@/store/index';
import axios from 'axios';
import { Module } from 'vuex';

function getApi(): LocationRoomTypeApi {
  return new LocationRoomTypeApi(
    undefined,
    import.meta.env.VITE_PROXY_URL,
    axios,
  );
}

const getDefaultState = () => ({
  roomTypes: [] as LocationRoomTypeRead[],
  loading: false,
});

export type roomTypesState = ReturnType<typeof getDefaultState>;

export const RoomTypes: Module<roomTypesState, State> = {
  namespaced: true,

  state: getDefaultState(),

  mutations: {
    setRoomTypes(state, response: LocationRoomTypesGetCollection200Response) {
      state.roomTypes = response['hydra:member'];
    },
    setLoading(state, isLoading: boolean) {
      state.loading = isLoading;
    },
  },

  actions: {
    async fetchRoomTypes({ commit }) {
      commit('setLoading', true);

      const api = getApi();
      const response = await api.locationRoomTypesGetCollection({});

      commit('setRoomTypes', response.data);
      commit('setLoading', false);
    },
  },

  getters: {
    getRoomTypeByRoom:
      (state) =>
      (room: ReservationRoomRead | BookingHotelRoomBookingBillingRead) => {
        const roomTypeID = parseInt(
          helpers.extractID(room.locationRoomType ?? room.roomTypeObject) ?? '',
          10,
        );
        return state.roomTypes.find((roomType) => {
          return roomType.id === roomTypeID;
        });
      },

    fetchAvailability:
      () =>
      async (
        room: { startDate?: string; endDate?: string },
        locationId?: number,
      ) => {
        const api = getApi();
        const response = await api.locationRoomTypesavailabilitiesGetCollection(
          {
            page: 1,
            itemsPerPage: 999,
            arrivalDate: room.startDate ?? undefined,
            departureDate: room.endDate ?? undefined,
            amount: 1,
            locationId,
          },
        );
        return response.data['hydra:member'];
      },
  },
};
